<template>
  <div style="min-height: 92vh">
    <v-row>
      <v-col md="12" cols="12">
        <ModuleHeader>Creador actividades</ModuleHeader>
      </v-col>
      <v-col md="12" cols="12">
        <DataTable
          :config="config"
          :data="actividades"
          :pageRows="15"
          @buttonClick="dtButtonClick"
        >
        </DataTable>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Actividades">
      <ActividadesForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
        :actividades="actividades"
      ></ActividadesForm>
    </modal>
  </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import DataTable from "../../MainComponents/DataTable.vue";
import ActividadesForm from "./CreadorActividadesForm.vue";

export default {
  name: "CreadorActividadesCrud",
  components: { DataTable, modal, ActividadesForm },
  data() {
    return {
      actividades: [],

      formIndex: 0,
      showModal: false,
      editMode: false,
      editData: {},

      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Actividades",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addActividad",
            require: false,
          },
          // {
          //   text: "Editar",
          //   icon: "lni lni-pencil-alt",
          //   buttonId: "editActividad",
          //   require: true,
          // },
          // {
          //   text: "Eliminar",
          //   icon: "lni lni-trash",
          //   buttonId: "deleteActividad",
          //   require: true,
          // },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Folio de Reservación",
            value: "sr",
          },
        ],
      },
    };
  },
  methods: {
    async getActividades() {
      let actividades = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Actividades"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
      } else {
        this.actividades = [];
      }
    },

    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addActividad") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.toggleModal(true);
      }
      if (buttonId == "editActividad") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.actividades,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }
      if (buttonId == "deleteActividad") {
        this.deleteSubcategoria(idSelected[0]);
      }
    },

    /** -------------------------------------------------------------- */
    successData(data) {
      let sendData = {
        nm: data.nm,
        sr: data.sr,
      };

      this.$pgsHelper.log("lo que se envìa", sendData);

      if (data.id == "") {
        this.createActividad(sendData);
      } else {
        sendData.id = data.id;
        this.editActividad(sendData);
      }

      //this.editProduct(data);
    },
    createActividad(datos) {
      this.$swal({
        title: "¿Deseas agregar esta nueva actividad?",
        text: "Podras editarla cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Actividades-createActividad", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La actividad se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getActividades();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    ////////////////////////////////////////////////////////////
    editActividad(datos) {
      this.$swal({
        title: "¿Deseas editar la actividad?",
        text: "La actividad será modificada",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La actividad se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getActividades();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    ////////////////////////////////////////////////////////////
    deleteSubcategoria(id) {
      let datos = { id: id };
      this.$swal({
        title: "¿Deseas eliminar la actividad?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "La actividad se elimino correctamente",
              "La actividad se elimino correctamente",
              "success"
            );
            this.getActividades();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    ////////////////////////////////////////////////////////////
    toggleModal(open) {
      this.showModal = open;
    },
    /** -------------------------------------------------------------- */
  },
  mounted: async function () {
    this.getActividades();
  },
};
</script>
